import * as api from '../connectivity/api.roles';
import { call, put } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import * as types from '../constants/actionTypes';
import { showLoading, hideLoading } from 'react-redux-loading-bar';


export function* doRequestDropboxRoles(action) {
    yield put(showLoading());

    try {
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'roles.doRequestDropboxRoles'
            }
        });

        const { dropboxId } = action.payload,
            dropbox_roles = yield call(api.fetchDropboxRoles, dropboxId)
        ;

        yield put({
            type: types.DROPBOXES__ROLES__REQUESTED__SUCCEEDED,
            payload: { dropbox_roles }
        });
    } catch (e) {
        yield put({
            type: types.DROPBOXES__ROLES__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'roles.doRequestDropboxRoles'
        }
    });

    yield put(hideLoading());
}

export function* doRequestDropboxRolesSucceeded(action) {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'roles.doRequestDropboxRoles'
        }
    });
}

export function* doRequestDropboxRolesFailed(action) {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'roles.doRequestDropboxRoles'
        }
    });
}

export function* doRequestRolesSelf(action) {
    yield put(showLoading());

    yield put({
        type: types.REQUEST__STARTED,
        payload: {
            requestFrom: 'roles.doRequestRolesSelf'
        }
    });

    try {

        const dropbox_roles = yield call(api.fetchRolesSelf);

        yield put({
            type: types.ROLES__SELF__REQUESTED__SUCCEEDED,
            payload: { dropbox_roles }
        });
    } catch (e) {
        yield put({
            type: types.ROLES__SELF__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'roles.doRequestRolesSelf'
        }
    });

    yield put(hideLoading());
}

export function* doRequestRolesSelfSucceeded(action) {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'roles.doRequestRolesSelf'
        }
    });
}

export function* doRequestRolesSelfFailed(action) {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'roles.doRequestRolesSelf'
        }
    });
}

export function* watchRequestDropboxRoles() {
    yield* takeLatest(types.DROPBOXES__ROLES__REQUESTED, doRequestDropboxRoles);
}

export function* watchRequestDropboxRolesSucceeded() {
    yield* takeLatest(types.DROPBOXES__ROLES__REQUESTED__SUCCEEDED, doRequestDropboxRolesSucceeded);
}

export function* watchRequestDropboxRolesFailed() {
    yield* takeLatest(types.DROPBOXES__ROLES__REQUESTED__FAILED, doRequestDropboxRolesFailed);
}

export function* watchRequestRolesSelf() {
    yield* takeLatest(types.ROLES__SELF__REQUESTED, doRequestRolesSelf);
}

export function* watchRequestRolesSelfSucceeded() {
    yield* takeLatest(types.ROLES__SELF__REQUESTED__SUCCEEDED, doRequestRolesSelfSucceeded);
}

export function* watchRequestRolesSelfFailed() {
    yield* takeLatest(types.ROLES__SELF__REQUESTED__FAILED, doRequestRolesSelfFailed);
}


/** WEBPACK FOOTER **
 ** ./src/sagas/roles.saga.js
 **/